import { defineComponent as _defineComponent } from 'vue'
import SideNav from '../../nav/SideNav.vue';
import { useAuthStore } from 'bd-common/src/store/authStore';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import BoxGrid from '../boxGrid/BoxGrid.vue';
import BoxGridItem from '../boxGrid/BoxGridItem.vue';
import { RouterView } from 'vue-router';
import PrivateTopNav from 'bd-common/src/components/nav/PrivateTopNav.vue';
import PublicTopNav from 'bd-common/src/components/nav/PublicTopNav.vue';
import AppLogo from '../AppLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavViewGrid',
  props: {
    hideSidebar: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { hideSidebar: boolean };



const authStore = useAuthStore();

const route = useRoute();

const isSidebarShown = computed(() => props.hideSidebar === false && authStore.isLoggedIn);

const hasSidebarView = computed(() => !!route.matched.find((r) => !!r.instances.sidebar));

const mainAreaDiv = ref<HTMLDivElement>();

expose({
  scrollView(y: number) {
    if (mainAreaDiv.value) {
      mainAreaDiv.value.scrollTop = y;
    }
  },
});

return { __sfc: true,props, authStore, route, isSidebarShown, hasSidebarView, mainAreaDiv, SideNav, BoxGrid, BoxGridItem, RouterView, PrivateTopNav, PublicTopNav, AppLogo }
}

})